import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../../hooks';
import Typography from '../../../../../components/Typography/Typography';
import classes from '../../../../../styles/AllDevices.module.css';
import { Form, Formik } from 'formik';
import { Input, TextArea } from '../../../../../components/Inputs/Input';
import Checkbox from '../../../../../components/Inputs/Checkbox/Checkbox';
import Table from '../../../../../components/Table/Table';
import PhoneNumberComponent from '../../../../../components/Inputs/PhoneNumberComponent';
import MultipleFilesUpload from '../../../../../components/Inputs/FileUpload/MultipleFileUpload';
import fileUploadClasses from '../../../../../components/Inputs/FileUpload/FileUpload.module.css';
import { UilFileDownload, UilTimesCircle } from '@iconscout/react-unicons';
import { OnboardingForm } from '../../../../../validations/Onboarding/OnboardingForm';
import homeClasses from '../../../../Home/Home.module.css';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { RootOnboardingService } from '../../../../../services/OnboardingService';

const CreateOnboardingForm = ({ editData = null, setModal, getData, onlyView = false }) => {
    const [startLoader, stopLoader] = useLoader();
    const [checkboxState, setCheckboxState] = useState({
        partner: {
            yes: _.get(editData, ['contractDetails', 'isPartnerContract'], true),
            no: !_.get(editData, ['contractDetails', 'isPartnerContract'], true),
        },
        agreement: {
            yes: _.get(editData, ['contractDetails', 'aggrementStandardPaymentTerms', 'status'], true),
            no: !_.get(editData, ['contractDetails', 'aggrementStandardPaymentTerms', 'status'], true),
        },
        loggingMeter: {
            yes: _.get(editData, ['projectDetails', 'loggingMeter', 'hasLoggingMeter'], true),
            no: !_.get(editData, ['projectDetails', 'loggingMeter', 'hasLoggingMeter'], true),
        },
        meterHasEthernet: {
            yes: _.get(editData, ['projectDetails', 'loggingMeter', 'meterHasEthernet'], true),
            no: !_.get(editData, ['projectDetails', 'loggingMeter', 'meterHasEthernet'], true),
        },
    });

    const [initialValues, setInitialValues] = useState({
        companyDetails: {
            companyName: _.get(editData, ['companyDetails', 'companyName'], ''),
            add1: _.get(editData, ['companyDetails', 'add1'], ''),
            add2: _.get(editData, ['companyDetails', 'add2'], ''),
            postcode: _.get(editData, ['companyDetails', 'postcode'], ''),
            city: _.get(editData, ['companyDetails', 'city'], ''),
            vat: _.get(editData, ['companyDetails', 'vat'], ''),
            referenceId: _.get(editData, ['companyDetails', 'referenceId'], ''),
        },
        contactDetails: {
            name: _.get(editData, ['contactDetails', 'name'], ''),
            primaryEmail: _.get(editData, ['contactDetails', 'primaryEmail'], ''),
            billingEmail: _.get(editData, ['contactDetails', 'billingEmail'], ''),
            contact: {
                countryCode: _.get(editData, ['contactDetails', 'contact', 'countryCode'], null),
                number: _.get(editData, ['contactDetails', 'contact', 'number'], null),
            },
        },
        contractDetails: {
            paymentTerms: _.get(editData, ['contractDetails', 'paymentTerms'], 0),
            isPartnerContract: _.get(editData, ['contractDetails', 'isPartnerContract'], null),
            fixedMonthlyFee: _.get(editData, ['contractDetails', 'fixedMonthlyFee'], 0),
            monthlyAdminFee: _.get(editData, ['contractDetails', 'monthlyAdminFee'], 0),
            aggrementStandardPaymentTerms: {
                status: _.get(editData, ['contractDetails', 'aggrementStandardPaymentTerms', 'status'], null),
                description: _.get(editData, ['contractDetails', 'aggrementStandardPaymentTerms', 'description'], ''),
            },
            tableData: {
                a: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'a', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'a', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'a', 'sc'], null),
                },
                b: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'b', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'b', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'b', 'sc'], null),
                },
                c: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'c', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'c', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'c', 'sc'], null),
                },
                d: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'd', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'd', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'd', 'sc'], null),
                },
                e: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'e', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'e', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'e', 'sc'], null),
                },
                f: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'f', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'f', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'f', 'sc'], null),
                },
                g: {
                    customer: _.get(editData, ['contractDetails', 'tableData', 'g', 'customer'], null),
                    partner: _.get(editData, ['contractDetails', 'tableData', 'g', 'partner'], null),
                    sc: _.get(editData, ['contractDetails', 'tableData', 'g', 'sc'], null),
                },
            },
        },
        projectDetails: {
            shipmentDetails: {
                name: _.get(editData, ['projectDetails', 'shipmentDetails', 'name'], ''),
                add1: _.get(editData, ['projectDetails', 'shipmentDetails', 'add1'], ''),
                add2: _.get(editData, ['projectDetails', 'shipmentDetails', 'add2'], ''),
                postcode: _.get(editData, ['projectDetails', 'shipmentDetails', 'postcode'], ''),
                city: _.get(editData, ['projectDetails', 'shipmentDetails', 'city'], ''),
                contact: {
                    countryCode: _.get(editData, ['projectDetails', 'shipmentDetails', 'contact', 'countryCode'], null),
                    number: _.get(editData, ['projectDetails', 'shipmentDetails', 'contact', 'number'], null),
                },
            },
            otherProjectDetails: _.get(editData, ['projectDetails', 'otherProjectDetails'], ''),
            gsrn: _.get(editData, ['projectDetails', 'gsrn'], ''),
            loggingMeter: {
                meterIpAddress: _.get(editData, ['projectDetails', 'loggingMeter', 'meterIpAddress'], ''),
                notes: _.get(editData, ['projectDetails', 'loggingMeter', 'notes'], ''),
            },
        },
    });

    const [files, setFiles] = useState(_.get(editData, 'files', []));

    const handleFilesSelect = (e) => {
        uploadFiles(e.target.files);
    };

    const uploadFiles = (selectedFiles) => {
        const tempFiles = [];
        const formData = new FormData();
        for (let i = 0; i < selectedFiles.length; i++) {
            tempFiles.push(selectedFiles[i]);
            formData.append('files', selectedFiles[i]);
        }
        // add raw File objects as placeholders (no "key") so they render with an "Uploading..." status until the server responds
        setFiles((prev) => [...prev, ...tempFiles]);
        RootOnboardingService.UploadFiles(formData, () => {}, handleUploadFilesSuccess, handleError, () => {});
    };

    const handleUploadFilesSuccess = ({ data }) => {
        setFiles((prev) => [...prev.filter((item) => item?.key), ...data.data]);
    };

    const removeFile = (key, id) => {
        if (id) RootOnboardingService.RemoveUploadedFile(editData?._id, id, startLoader, handleRemoveFileSuccess, handleError, stopLoader);
        setFiles((prev) => prev.filter((item) => item.key !== key));
    };

    const handleRemoveFileSuccess = () => {
        toast.success('File removed successfully');
        getData();
    };

    const downloadFile = (key) => {
        RootOnboardingService.GetUploadedFileSignedURL({ key }, startLoader, handleFileSignedURLSuccess, handleError, stopLoader);
    };

    const handleFileSignedURLSuccess = ({ data }) => {
        if (data.data?.signedUrl) window.open(data.data.signedUrl, '_blank');
    };

    const handleCheckbox = (type, value, key) => {
        if (key === 'yes' && value) setCheckboxState((prev) => ({ ...prev, [type]: { yes: true, no: false } }));
        if (key === 'no' && value) setCheckboxState((prev) => ({ ...prev, [type]: { yes: false, no: true } }));
    };

    const tableColStyle = (text = '') => {
        return <span style={{ fontWeight: '600' }}>{text}</span>;
    };

    const handleSubmit = (value) => {
        value.contractDetails.isPartnerContract = _.get(checkboxState, ['partner', 'yes']);
        value.contractDetails.aggrementStandardPaymentTerms.status = _.get(checkboxState, ['agreement', 'yes']);
        value.projectDetails.loggingMeter.hasLoggingMeter = _.get(checkboxState, ['loggingMeter', 'yes']);
        value.projectDetails.loggingMeter.meterHasEthernet = _.get(checkboxState, ['meterHasEthernet', 'yes']);

        if (!value.contractDetails.isPartnerContract) {
            for (const key in value.contractDetails.tableData) {
                value.contractDetails.tableData[key].partner = null;
            }
        }

        value.files = files;

        if (editData?._id) RootOnboardingService.Update(editData?._id, value, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = () => {
        toast.success('Form Updated Successfully');
        setModal({ status: false, data: null, onlyView: false });
        getData();
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    return (
        <div className={`${classes.FormContainer} ${homeClasses.OnboardingHeader}`}>
            <div className={classes.FormContent}>
                <Formik
                    enableReinitialize
                    onSubmit={handleSubmit}
                    initialValues={initialValues}
                    validationSchema={OnboardingForm(
                        _.get(checkboxState, ['partner', 'yes']),
                        _.get(checkboxState, ['meterHasEthernet', 'yes']),
                        _.get(checkboxState, ['loggingMeter', 'yes']),
                    )}
                >
                    {({ errors, touched, values, isValidating, ...props }) => {
                        return (
                            <Form>
                                <fieldset
                                    disabled={onlyView}
                                    style={{
                                        border: '0',
                                        padding: '0',
                                        margin: '0',
                                    }}
                                >
                                    <div>
                                        <div style={{ marginBottom: '1vh' }}>
                                            <Typography content={'Company Information'} />
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Company Name <span className="required">*</span>
                                                </label>
                                                <Input name="companyDetails.companyName" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Add 1 <span className="required">*</span>
                                                </label>
                                                <Input name="companyDetails.add1" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>Add 2</label>
                                                <Input name="companyDetails.add2" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Postcode <span className="required">*</span>
                                                </label>
                                                <Input name="companyDetails.postcode" type="number" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    City <span className="required">*</span>
                                                </label>
                                                <Input name="companyDetails.city" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Vat/CVR <span className="required">*</span>
                                                </label>
                                                <Input name="companyDetails.vat" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>Reference ID for kunden</label>
                                                <Input name="companyDetails.referenceId" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}></div>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '2.5vh' }}>
                                        <div style={{ marginBottom: '1vh' }}>
                                            <Typography content={'Contact Details'} />
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Name <span className="required">*</span>
                                                </label>
                                                <Input name="contactDetails.name" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Primary Email <span className="required">*</span>
                                                </label>
                                                <Input name="contactDetails.primaryEmail" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Billing Email <span className="required">*</span>
                                                </label>
                                                <Input name="contactDetails.billingEmail" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Contact <span className="required">*</span>
                                                </label>
                                                <div>
                                                    <PhoneNumberComponent
                                                        inputName="contactDetails.contact.number"
                                                        countryCodeName="contactDetails.contact.countryCode"
                                                        inputValues={values}
                                                        defaultCountryCode={{
                                                            value: initialValues?.contactDetails.contact?.countryCode,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '2.5vh' }}>
                                        <div style={{ marginBottom: '1vh' }}>
                                            <Typography content={'Contract Details'} />
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Payment Terms (days) <span className="required">*</span>
                                                </label>
                                                <Input name="contractDetails.paymentTerms" type="number" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Fixed monthly fee for asset <span className="required">*</span>
                                                </label>
                                                <Input name="contractDetails.fixedMonthlyFee" type="number" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer} style={{ alignItems: 'center' }}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Monthly admin fee <span className="required">*</span>
                                                </label>
                                                <Input name="contractDetails.monthlyAdminFee" type="number" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Is it a partner contract <span className="required">*</span>
                                                </label>
                                                <div style={{ display: 'flex', gap: '1vw' }}>
                                                    <Checkbox checked={checkboxState.partner.yes} label={'Yes'} onChange={(e) => handleCheckbox('partner', e, 'yes')} />
                                                    <Checkbox checked={checkboxState.partner.no} label={'No'} onChange={(e) => handleCheckbox('partner', e, 'no')} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer} style={{ alignItems: 'center' }}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Is the agreement standard payment terms <span className="required">*</span>
                                                </label>
                                                <div style={{ display: 'flex', gap: '1vw' }}>
                                                    <Checkbox checked={checkboxState.agreement.yes} label={'Yes'} onChange={(e) => handleCheckbox('agreement', e, 'yes')} />
                                                    <Checkbox checked={checkboxState.agreement.no} label={'No'} onChange={(e) => handleCheckbox('agreement', e, 'no')} />
                                                </div>
                                            </div>
                                            {checkboxState.agreement.no && (
                                                <div className={classes.FieldControl2}>
                                                    <label>Is the agreement standard payment terms Details</label>
                                                    <TextArea name="contractDetails.aggrementStandardPaymentTerms.description" />
                                                </div>
                                            )}
                                        </div>
                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <Table
                                                    head={['Fase', 'Beskrivelse', 'Customer', checkboxState.partner.yes ? 'Partner' : '', 'SC']}
                                                    keys={['sno', 'beskrivelse', 'customer', checkboxState.partner.yes ? 'partner' : '', 'sc']}
                                                    data={[
                                                        {
                                                            sno: 1,
                                                            beskrivelse: tableColStyle('Afholdelse af omkostningerne til projekt etablering'),
                                                            customer: (
                                                                <>
                                                                    <Input
                                                                        label={'Percentage'}
                                                                        name="contractDetails.tableData.a.customer"
                                                                        type="number"
                                                                        style={{ marginTop: '0' }}
                                                                    />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'Percentage'}
                                                                                  name="contractDetails.tableData.a.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'Percentage'} name="contractDetails.tableData.a.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: '',
                                                            beskrivelse: tableColStyle('Etablering og frem til godkendelse og idriftsættelse (ref. Bilag 6.1 og stk. 6.2)'),
                                                            customer: '',
                                                            ...(checkboxState.partner.yes ? { partner: '' } : {}),
                                                            sc: '',
                                                        },
                                                        {
                                                            sno: 2,
                                                            beskrivelse: tableColStyle('Fast månedligt honorar (per anlæg, eller MW der administreres)'),
                                                            customer: (
                                                                <>
                                                                    <Input label={'kr'} name="contractDetails.tableData.b.customer" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'kr'}
                                                                                  name="contractDetails.tableData.b.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'kr'} name="contractDetails.tableData.b.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: 3,
                                                            beskrivelse: tableColStyle('SC’s andel indtil Punkt 1 er tjent hjem'),
                                                            customer: (
                                                                <>
                                                                    <Input
                                                                        label={'Percentage'}
                                                                        name="contractDetails.tableData.c.customer"
                                                                        type="number"
                                                                        style={{ marginTop: '0' }}
                                                                    />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'Percentage'}
                                                                                  name="contractDetails.tableData.c.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'Percentage'} name="contractDetails.tableData.c.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: 4,
                                                            beskrivelse: tableColStyle('Håndtering af auditeringer (per anlæg, eller MW der administreres)'),
                                                            customer: (
                                                                <>
                                                                    <Input label={'kr'} name="contractDetails.tableData.d.customer" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'kr'}
                                                                                  name="contractDetails.tableData.d.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'kr'} name="contractDetails.tableData.d.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: 5,
                                                            beskrivelse: tableColStyle('Løbende andel af værdiskabelsen'),
                                                            customer: '',
                                                            ...(checkboxState.partner.yes ? { partner: '' } : {}),
                                                            sc: '',
                                                        },
                                                        {
                                                            sno: '',
                                                            beskrivelse: tableColStyle('0-2 MW'),
                                                            customer: (
                                                                <>
                                                                    <Input
                                                                        label={'Percentage'}
                                                                        name="contractDetails.tableData.e.customer"
                                                                        type="number"
                                                                        style={{ marginTop: '0' }}
                                                                    />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'Percentage'}
                                                                                  name="contractDetails.tableData.e.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'Percentage'} name="contractDetails.tableData.e.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: '',
                                                            beskrivelse: tableColStyle('Above 2-5 MW'),
                                                            customer: (
                                                                <>
                                                                    <Input
                                                                        label={'Percentage'}
                                                                        name="contractDetails.tableData.f.customer"
                                                                        type="number"
                                                                        style={{ marginTop: '0' }}
                                                                    />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'Percentage'}
                                                                                  name="contractDetails.tableData.f.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'Percentage'} name="contractDetails.tableData.f.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                        {
                                                            sno: '',
                                                            beskrivelse: tableColStyle('Herefter'),
                                                            customer: (
                                                                <>
                                                                    <Input
                                                                        label={'Percentage'}
                                                                        name="contractDetails.tableData.g.customer"
                                                                        type="number"
                                                                        style={{ marginTop: '0' }}
                                                                    />
                                                                </>
                                                            ),
                                                            ...(checkboxState.partner.yes
                                                                ? {
                                                                      partner: (
                                                                          <>
                                                                              <Input
                                                                                  label={'Percentage'}
                                                                                  name="contractDetails.tableData.g.partner"
                                                                                  type="number"
                                                                                  style={{ marginTop: '0' }}
                                                                              />
                                                                          </>
                                                                      ),
                                                                  }
                                                                : {}),
                                                            sc: (
                                                                <>
                                                                    <Input label={'Percentage'} name="contractDetails.tableData.g.sc" type="number" style={{ marginTop: '0' }} />
                                                                </>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '2.5vh' }}>
                                        <div style={{ marginBottom: '1vh' }}>
                                            <Typography content={'Project Details'} />
                                        </div>

                                        <div>
                                            <Typography content={'Shipment Details'} subtext={true} />
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Name <span className="required">*</span>
                                                </label>
                                                <Input name="projectDetails.shipmentDetails.name" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Add 1 <span className="required">*</span>
                                                </label>
                                                <Input name="projectDetails.shipmentDetails.add1" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>Add 2</label>
                                                <Input name="projectDetails.shipmentDetails.add2" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Postcode <span className="required">*</span>
                                                </label>
                                                <Input name="projectDetails.shipmentDetails.postcode" type="number" style={{ marginTop: '0' }} />
                                            </div>
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    City <span className="required">*</span>
                                                </label>
                                                <Input name="projectDetails.shipmentDetails.city" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    Contact <span className="required">*</span>
                                                </label>
                                                <div>
                                                    <PhoneNumberComponent
                                                        inputName="projectDetails.shipmentDetails.contact.number"
                                                        countryCodeName="projectDetails.shipmentDetails.contact.countryCode"
                                                        inputValues={values}
                                                        defaultCountryCode={{
                                                            value: initialValues?.projectDetails.contact?.countryCode,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={classes.InputContainer} style={{ alignItems: 'center' }}>
                                            <div className={classes.FieldControl2}>
                                                <label>
                                                    GSRN Number <span className="required">*</span>
                                                </label>
                                                <Input name="projectDetails.gsrn" style={{ marginTop: '0' }} />
                                            </div>
                                            <div className={classes.FieldControl2}>
                                                <div className={classes.InputContainer}>
                                                    <div className={classes.FieldControl2}>
                                                        <label>
                                                            Do you have a logging meter installed <span className="required">*</span>
                                                        </label>
                                                        <div style={{ display: 'flex', gap: '1vw' }}>
                                                            <Checkbox
                                                                checked={checkboxState.loggingMeter.yes}
                                                                label={'Yes'}
                                                                onChange={(e) => handleCheckbox('loggingMeter', e, 'yes')}
                                                            />
                                                            <Checkbox
                                                                checked={checkboxState.loggingMeter.no}
                                                                label={'No'}
                                                                onChange={(e) => handleCheckbox('loggingMeter', e, 'no')}
                                                            />
                                                        </div>
                                                    </div>
                                                    {checkboxState.loggingMeter.yes && (
                                                        <div className={classes.FieldControl2}>
                                                            <label>
                                                                Does the meter have Ethernet <span className="required">*</span>
                                                            </label>
                                                            <div style={{ display: 'flex', gap: '1vw' }}>
                                                                <Checkbox
                                                                    checked={checkboxState.meterHasEthernet.yes}
                                                                    label={'Yes'}
                                                                    onChange={(e) => handleCheckbox('meterHasEthernet', e, 'yes')}
                                                                />
                                                                <Checkbox
                                                                    checked={checkboxState.meterHasEthernet.no}
                                                                    label={'No'}
                                                                    onChange={(e) => handleCheckbox('meterHasEthernet', e, 'no')}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {checkboxState.meterHasEthernet.yes && checkboxState.loggingMeter.yes && (
                                            <div className={classes.InputContainer}>
                                                <div className={classes.FieldControl2}>
                                                    <label>Notes</label>
                                                    <TextArea name="projectDetails.loggingMeter.notes" />
                                                </div>
                                                <div className={classes.FieldControl2}>
                                                    <label>
                                                        IP address for the meter <span className="required">*</span>
                                                    </label>
                                                    <Input name="projectDetails.loggingMeter.meterIpAddress" style={{ marginTop: '0' }} />
                                                </div>
                                            </div>
                                        )}
                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>Other Project Details</label>
                                                <TextArea name="projectDetails.otherProjectDetails" />
                                            </div>
                                            <div className={classes.FieldControl2}></div>
                                        </div>
                                    </div>

                                    <div style={{ marginTop: '2.5vh' }}>
                                        <div style={{ marginBottom: '1vh' }}>
                                            <Typography content={'Documents'} />
                                        </div>

                                        <div className={classes.InputContainer}>
                                            <div className={classes.FieldControl2}>
                                                <label>Upload Documents</label>
                                                <MultipleFilesUpload name="uploadFiles" id="uploadFiles" accept="*" multiple onChange={handleFilesSelect} />
                                            </div>
                                            <div className={classes.FieldControl2}></div>
                                        </div>

                                        {files?.length ? (
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '0.5vw' }}>
                                                {files.map((item, index) => (
                                                    <div key={index}>
                                                        <div className={fileUploadClasses.SelectedFile}>
                                                            <p>{item.name}</p>
                                                            {item?.key && (
                                                                <div style={{ display: 'flex' }}>
                                                                    <div onClick={() => downloadFile(item.key)} className={fileUploadClasses.CloseIcon}>
                                                                        <UilFileDownload style={{ color: 'var(--color-primary)' }} size={'1.3vw'} />
                                                                    </div>
                                                                    {!onlyView && (
                                                                        <div onClick={() => removeFile(item.key, item._id)} className={fileUploadClasses.CloseIcon}>
                                                                            <UilTimesCircle style={{ color: 'var(--color-primary)' }} size={'1.3vw'} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        {!item?.key && <p className={fileUploadClasses.Uploading}>Uploading...</p>}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </fieldset>
                                <div className={classes.ButtonContainer}>
                                    <div onClick={() => setModal({ status: false, data: null, onlyView: false })}>
                                        <button type="submit" className="btn-secondary">
                                            Cancel
                                        </button>
                                    </div>
                                    {!onlyView && (
                                        <div>
                                            <button type="submit" className="btn-primary">
                                                Submit
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

export default CreateOnboardingForm;
